/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import {
  AvatarName,
  NotificationIcon,
  Question,
  SelectLang,
  ThemeToggle,
} from '@zhiyue/core';

import AvatarDropdown from './AvatarDropdown';
import Footer from './Footer';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  NotificationIcon,
  Question,
  SelectLang,
  ThemeToggle,
};
